import { SYSTEMS } from "./investData";

export const InvestorNarrative = () => (
  <>
    <section id="briefing" className="border-b border-[color:var(--line)]" data-testid="invest-why">
      <div className="mx-auto grid max-w-site grid-cols-1 px-6 py-24 md:grid-cols-12 md:px-10 md:py-32">
        <div className="md:col-span-4">
          <div className="label !text-[10px] text-[color:var(--ink-3)]">01 / Why this exists</div>
          <p className="mt-4 max-w-xs editorial text-xl leading-snug text-[color:var(--ink-2)]">
            Performance should not cost you your health.
          </p>
        </div>
        <div className="mt-12 md:col-span-8 md:mt-0">
          <h2 className="max-w-3xl font-display text-4xl leading-[1.02] sm:text-5xl" data-testid="invest-why-title">
            Three founders.<br /><span className="editorial font-normal">One promise.</span>
          </h2>
          <div className="mt-10 grid gap-7 text-[15px] leading-relaxed text-[color:var(--ink-2)] md:grid-cols-2 md:gap-12">
            <p>
              Vitura Labs™ was founded in 2025 by Andrew Hill, Dave Salvant and Verick Wayne on a simple premise: performance should not cost you your health. Most products give you energy. Some help you focus. Almost none support energy, focus, mood and recovery without overstimulation, burnout or a crash.
            </p>
            <p>
              Vitura combines clinically studied nootropics, adaptogens and functional botanicals that work together—not against you. The result is a 2oz daily ritual engineered for moving bodies and focused minds across the whole day, not one hour of it.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="border-b border-[color:var(--line)] bg-[color:var(--bg-soft)]" data-testid="invest-systems">
      <div className="mx-auto max-w-site px-6 py-24 md:px-10 md:py-32">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="label !text-[10px] text-[color:var(--ink-3)]">02 / Product thesis</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-4xl leading-[1.02] sm:text-5xl" data-testid="invest-systems-title">
              One shot, <span className="editorial font-normal">four systems.</span>
            </h2>
            <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-[color:var(--ink-2)]">
              Fifteen active ingredients organized around the four outputs high performers manage every day.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 border-l border-t border-[color:var(--line)] md:grid-cols-2">
          {SYSTEMS.map((system) => (
            <article key={system.name} className="min-h-[300px] border-b border-r border-[color:var(--line)] p-7 md:p-10" data-testid={`invest-system-${system.name.toLowerCase()}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-[10px] text-[color:var(--ink-3)]">{system.index}</span>
                <span className="label !text-[9px] text-[color:var(--ink-3)]">{system.name}</span>
              </div>
              <h3 className="mt-10 max-w-sm font-display text-3xl leading-tight">{system.title}</h3>
              <p className="mt-5 max-w-md text-sm leading-relaxed text-[color:var(--ink-2)]">{system.ingredients}</p>
              <p className="mt-7 max-w-sm editorial text-xl leading-snug">{system.outcome}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  </>
);